import React from 'react';

const VIEW = 16;
const CX = 8;
const CY = 8;
const DEFAULT_R = 5;

const ProgressRing = ({
  percent = 0,
  size = 20,
  trackColor = '#E3E3E3',
  progressColor = '#27AE60',
  strokeWidth = 2,
}) => {
  const n = Number(percent);
  const clamped = Math.min(100, Math.max(0, Number.isFinite(n) ? n : 0));
  const circumference = 2 * Math.PI * DEFAULT_R;
  const dashOffset = circumference * (1 - clamped / 100);

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VIEW} ${VIEW}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle
        cx={CX}
        cy={CY}
        r={DEFAULT_R}
        stroke={trackColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
      <circle
        cx={CX}
        cy={CY}
        r={DEFAULT_R}
        stroke={progressColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        transform={`rotate(-90 ${CX} ${CY})`}
      />
    </svg>
  );
};

export default ProgressRing;
